'use client';

import type { IconProps } from '@crehana/compass.icons.fill/types';

import { clsx } from 'clsx';
import { useState } from 'react';

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/shared/components/ui/popover';

type TOptionsButtonProps = {
  classNameButton: string;
  labelButton: string;
  Icon?: React.FC<IconProps>;
  classNameIcon?: string;
  options: { label: string; value: string }[] | undefined;
  width: string;
  optionSelect: (data: string) => void;
  disabled?: boolean;
};

export const OptionsButton: React.FC<TOptionsButtonProps> = ({
  classNameButton,
  options,
  labelButton,
  Icon,
  classNameIcon,
  width,
  optionSelect,
  disabled,
}) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <>
      <Popover>
        <PopoverTrigger asChild>
          <button
            type="button"
            className={classNameButton}
            onClick={() => setIsOpen(true)}
            disabled={disabled}
          >
            {Icon && (
              <Icon
                size={21}
                className={
                  classNameIcon ? classNameIcon : 'tw-text-neutral-light-700'
                }
              />
            )}
            {labelButton}
          </button>
        </PopoverTrigger>

        {isOpen && (
          <PopoverContent className="tw-rounded-lg tw-shadow-lg tw-mt-2 tw-py-0 tw-bg-white tw-border tw-border-neutral-light-500">
            <div className={clsx('tw-relative tw-flex', width)}>
              <div className="tw-absolute -tw-top-0.8 tw-left-[46%] tw-transform tw-border-t-2 tw-border-neutral-light-100 tw-border-solid tw-w-[1.8rem] tw-rotate-45 tw-bg-white"></div>
              {options != undefined && (
                <div className="tw-rounded-1 tw-z-7">
                  {options.map((option, index) => (
                    <div key={option.value}>
                      <button
                        type="button"
                        onClick={() => {
                          optionSelect(option.value);
                        }}
                        className={clsx(
                          index === 0 ? 'tw-rounded-tr-1 tw-rounded-tl-1' : '',
                          index === options.length
                            ? 'tw-rounded-br-1 tw-rounded-bl-1'
                            : '',
                          'tw-block tw-w-full tw-text-left tw-px-2.4 tw-py-1.2  tw-font-body4 hover:tw-bg-neutral-light-300 hover:tw-text-primary-light-500',
                        )}
                      >
                        {option.label}
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </PopoverContent>
        )}
      </Popover>
    </>
  );
};
